import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <div className="landing-root">
      {/* Header */}
      <header className="landing-header">
        <div className="landing-logo">
          <span className="rocket-emoji">🚀</span>
          <div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', height: '100%' }}>
              <span className="brand-title-row" style={{ fontWeight: 900, fontSize: 34, color: '#3deaff', letterSpacing: 0.5, lineHeight: 1, display: 'block' }}>
                  Q<span style={{ fontWeight: 700, fontSize: 35, color: '#3deaff', marginLeft: 0 }}>TradeView</span>
              </span>
              <span style={{ fontSize: 11, color: '#bfc9db', fontWeight: 700,fontStyle:'italic', textTransform:'uppercase',display: 'flex', alignItems: 'center', lineHeight: 1.2 }}>
                  High-Frequency Trading Engine
                  <span style={{ color: '#FFD600', fontSize: 9, marginLeft: 2 }}>★</span>
              </span>
          </div>
</div>

        </div>
        <div className="landing-header-actions">
          <button className="landing-btn secondary" onClick={() => navigate('/login')}>Login</button>
          {/* <button className="landing-btn primary" onClick={() => navigate('/register')}>Get Started</button> */}
        </div>
      </header>

      {/* Hero Section */}
      <section className="landing-hero">
        {/* <div className="hero-badge">⚡ Next-Generation Trading Platform</div> */}
        <h1 className="hero-title">Trade with <span className="brand-gradient">Precision</span></h1>
        <div className="hero-desc">
          Advanced algorithmic trading platform with real-time market data,<br />
          sophisticated charting tools, and institutional-grade execution capabilities.
        </div>
        <div className="hero-actions">
          <button className="landing-btn primary" onClick={() => navigate('/login')}>Start Trading Now →</button>
          <button className="landing-btn outline">▶ Watch Demo</button>
        </div>
        <div className="hero-stats">
          <div><span>50ms</span><br />Average Latency</div>
          <div><span>99.9%</span><br />Uptime</div>
          <div><span>24/7</span><br />Support</div>
        </div>
        <div className="hero-dashboard-mock">
          <img
            src="/laptops-graph.png"
            alt="Trading platform chart preview"
            className="laptop-graph-img"
          />
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="why-section">
        <h2>Why Choose QuantFIX?</h2>
        <div className="why-subtitle">Built for professional traders who demand speed, reliability, and advanced analytics</div>
        <div className="why-features">
          <div className="why-feature">
            <div className="why-icon">📈</div>
            <div>
              <div className="why-title">Advanced Analytics</div>
              <div className="why-desc">Real-time market data with sophisticated charting tools and technical indicators for informed decision making.</div>
            </div>
          </div>
          <div className="why-feature">
            <div className="why-icon">⚡</div>
            <div>
              <div className="why-title">Lightning Fast</div>
              <div className="why-desc">Ultra-low latency execution with sub-50ms order processing for competitive advantage in fast markets.</div>
            </div>
          </div>
          <div className="why-feature">
            <div className="why-icon">🛡️</div>
            <div>
              <div className="why-title">Bank-Grade Security</div>
              <div className="why-desc">Enterprise-level security with end-to-end encryption and multi-factor authentication for your peace of mind.</div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stat"><span>$2.5T+</span><br />Daily Volume</div>
        <div className="stat"><span>150+</span><br />Markets</div>
        <div className="stat"><span>500K+</span><br />Active Traders</div>
        <div className="stat"><span>15+</span><br />Years Experience</div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="rocket-emoji">🚀</span>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', height: '100%' }}>
              <span className="brand-title-row" style={{ fontWeight: 900, fontSize: 34, color: '#3deaff', letterSpacing: 0.5, lineHeight: 1, display: 'block' }}>
                  Q<span style={{ fontWeight: 700, fontSize: 35, color: '#3deaff', marginLeft: 0 }}>TradeView</span>
              </span>
              <span style={{ fontSize: 11, color: '#bfc9db', fontWeight: 700,fontStyle:'italic', textTransform:'uppercase',display: 'flex', alignItems: 'center', lineHeight: 1.2 }}>
                  High-Frequency Trading Engine
                  <span style={{ color: '#FFD600', fontSize: 9, marginLeft: 2 }}>★</span>
              </span>
          </div>


          </div>
          <div className="footer-links">
            <a href="#" className="footer-link">Home</a>
            <a href="#" className="footer-link">Features</a>
            <a href="#" className="footer-link">Pricing</a>
            <a href="#" className="footer-link">Contact</a>
          </div>
        </div>
        <div className="footer-bottom">
          © {new Date().getFullYear()} Q TradeView. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default LandingPage; 